module.exports = __webpack_public_path__ + "img/jidian_kongzhixitong.12e3d078.png";